<template>
    <section class="sidebarFilter">
        <p class="sidebarFilter__desc">{{ trans('EXTENDED_SEARCH_INDUSTRY_FILTER_DESCRIPTION') }}</p>
        <CustomDropdownB
            id="inlineDropdown__industry"
            class="sidebarFilter__industryDropdown"
            data-gtm="sidebarFilter__industry"
            :value="ALL_VALUE"
            :options="branchesData"
            element="sidebarFilter__industry"
            :bordered="true"
            @changeValue="setIndustry" />
        <div v-if="selectedCategory !== [ALL_VALUE]">
            <div
                class="hidden"
                v-html="subCategoryHTML">
            </div>
            <div v-if="subCategoryHTML.length > 0">
                <p class="entity__headline entity__headline--dark margin-top-10">
                    <label for="subCategory">
                        {{ trans('EXTENDED_SEARCH_INDUSTRY_FILTER_SUBCATEGORY') }}
                    </label>
                </p>

                <label
                    v-for="subIndustry in subCategoryHTML"
                    :key="subIndustry.id"
                    class="sidebarFilter__wrapperCheckBox sidebarFilter__wrapperIndustry">
                    <span class="sidebarFilter__checkBox sidebarFilter__industryCheckBox">
                        <input
                            ref="checkbox"
                            v-model="selectedCategoriesPill"
                            :data-gtm="`sidebarFilter__subIndustry--option${ subIndustry.id }`"
                            type="checkbox"
                            class="customCheckboxInput"
                            :value="subIndustry"
                            :checked="subIndustry.isChecked"
                            :multiple="true"
                            @change="setSubIndustry(subIndustry); setSelectedSubIndustries(subIndustry.label)" />
                        <span class="customCheckbox"></span>
                        {{ subIndustry.label }}
                    </span>
                </label>
            </div>
        </div>
        <div
            class="selectedSubIndustries flex"
            :class="selectedCategoriesPill < 1 ? 'hidden' : ''">
            <div
                class="subIndustryPill__wrapper"
                v-for="subIndustryPill in selectedCategoriesPill"
                :key="subIndustryPill.label">
                <button
                    v-if="subIndustryPill.parentId !== null"
                    type="button"
                    :data-gtm="`subIndustryPill__${ subIndustryPill.label }`"
                    :aria-label="`subIndustryPill--${ subIndustryPill.label }`"
                    class="facetedSearch__tag facetedSearch__tag--selected flex flex__alignItems--center"
                    @click="removeSubIndustry(subIndustryPill)">
                    {{ subIndustryPill.label }}
                    <svg
                        height="16"
                        width="16"
                        aria-hidden="true"
                        class="pill__icon">
                        <use href="#iconCrossBold" />
                    </svg>
                </button>
            </div>
        </div>
        <div
            class="selectedIndustries flex facetedSearch__content"
            :class="selectedCategoriesPill < 1 ? 'hidden' : ''">
            <button
                v-for="subIndustryPill in categoriesArray"
                :key="subIndustryPill.label"
                type="button"
                :data-gtm="`subIndustryPill__${ subIndustryPill.label }`"
                :aria-label="`subIndustryPill--${ subIndustryPill.label }`"
                class="facetedSearch__tag facetedSearch__tag--mobile flex flex__alignItems--center"
                @click="removeSubIndustry(subIndustryPill)">
                {{ subIndustryPill.label }}
                <svg
                    height="16"
                    width="16"
                    aria-hidden="true"
                    class="pill__icon">
                    <use href="#iconCrossBold" />
                </svg>
            </button>
        </div>
    </section>
</template>

<script>
    import CustomDropdownB from './searchDropdown';
    import axios from 'axios';
    import { useGetters, useActions } from 'composables/useVuex';
    import { mapActions } from 'vuex';
    import Translator from 'tools/trans';
    // 0 value equals 'all'
    const ALL_VALUE = '0';
    export default {
        name: 'IndustryFilter',
        components: {
            CustomDropdownB,
        },
        data() {
            return {
                industryIsSelected: false,
                selectedCategory: this.category,
                selectedSubCategory: this.subCategory,
                subCategoryHTML: [],
                selectedCategoriesPill: [],
                industryValue: '',
                mainCategoryArray: [],
                subCategoryArray: [],
                ALL_VALUE: ALL_VALUE,
                selectedCategoriesValue: {},
            };
        },
        computed: {
            categoryIdArray() {
                return [...new Set(this.selectedCategoriesPill.map(obj => obj.parentId))];
            },
            categoriesArray() {
                return this.branchesData.filter(obj => this.categoryIdArray.includes(obj.data));

            },
        },
        methods: {
            ...mapActions('search', ['setSelectedSubIndustries']),
            trans: Translator.trans,
            setIndustry(industry) {
                // if all categories were selected emit 'all'
                if (this.selectedCategory.length === (this.branchesData.length -1)) {
                    this.selectedCategory = [ALL_VALUE];
                }
                // set selected industry value to search within the branchesdata object for the main industry object
                this.industryValue = industry;

                if (industry !== ALL_VALUE) {
                    this.fetchSubCategories(industry);
                } else {
                    this.subCategoryHTML = [];
                    this.setSubIndustry(ALL_VALUE);
                    this.selectedSubCategory = [];
                    this.selectedCategory = [];
                }
                if (this.selectedCategory.length > 0 && !this.selectedCategory.includes('0')) {
                    this.selectedCategory.push(industry);
                } else {
                    this.selectedCategory = [industry];
                }

                this.emitEvent();
            },
            setSubIndustry(subIndustry) {

                //const foundValue = this.isInObject(this.subCategoryArray, subIndustry.value);
                let foundValue = false;
                this.subCategoryArray.forEach((item) => {
                    if (item.id === subIndustry.id) {
                        foundValue = true;
                    }
                });
                if (foundValue) {
                    const position = this.subCategoryArray.findIndex((item) => item.id === subIndustry.id);

                    if (position > -1) {
                        this.subCategoryArray.splice(this.subCategoryArray.indexOf(position), 1);
                    }

                } else {
                    this.subCategoryArray.push(subIndustry);
                }
                this.selectedSubCategory = [];
                this.selectedCategory = [];
                this.selectedCategoriesPill.forEach((value) => {
                    this.selectedSubCategory.push(value.id.toString());
                });
                if (this.selectedSubCategory.length > 0) {
                    this.selectedCategory = [...new Set(this.selectedCategoriesPill.map(obj => obj.parentId))];
                } else {
                    this.selectedCategory = [Number(this.industryValue)];
                }

                this.emitEvent();
            },
            async fetchSubCategories(industry) {
                const bodyFormData = new FormData();

                bodyFormData.append('category', industry);
                await axios({
                    method: 'post',
                    url: '/getSubBranches/',
                    data: bodyFormData,
                    headers: { 'Content-Type': 'multipart/form-data' },
                }).then(response => {
                    this.subCategoryHTML = response.data;
                });
            },
            isInObject(searchArray, compareValue) {
                let foundValue = false;
                searchArray.forEach((item) => {
                    if (item.value === compareValue) {
                        foundValue = true;
                    }
                });

                return foundValue;
            },
            removeSubIndustry(selectedPill) {
                if (Object.prototype.hasOwnProperty.call(selectedPill, 'parentId')) {
                    const indexToRemove = this.selectedCategoriesPill.findIndex(obj => obj.id === selectedPill.id);
                    if (indexToRemove !== -1) {
                        this.selectedCategoriesPill.splice(indexToRemove, 1);
                    }
                    this.selectedSubCategory = this.selectedSubCategory.filter(subCategory => subCategory !== selectedPill.id.toString());
                } else {
                    for (let i = this.selectedCategoriesPill.length - 1; i >= 0; i--) {
                        if (this.selectedCategoriesPill[i].parentId === selectedPill.data) {
                            this.selectedCategoriesPill.splice(i, 1);
                        }
                    }
                }
                this.selectedSubCategory = [];
                this.selectedCategory = [];
                this.selectedCategoriesPill.forEach((value) => {
                    this.selectedSubCategory.push(value.id.toString());
                });
                if (this.selectedSubCategory.length > 0) {
                    this.selectedCategory = [...new Set(this.selectedCategoriesPill.map(obj => obj.parentId))];
                } else {

                    this.selectedCategory = [Number(this.industryValue)];
                }

                if (this.selectedSubCategory.length === 0) {
                    this.selectedCategoriesPill = [];
                    this.selectedSubCategory = [ALL_VALUE];
                }
                this.emitEvent();
            },
            emitEvent() {
                this.$emit('selected-sub-category', this.selectedSubCategory);
                this.$parent.$emit('selected-sub-category', this.selectedSubCategory); //TODO Change it to store.state
                if (this.selectedCategory.length > 1) {
                    this.selectedCategory = this.selectedCategory.filter(categoryId => (categoryId && categoryId !== 0));
                }
                this.$emit('selected-category', this.selectedCategory);
                this.$parent.$emit('selected-category', this.selectedCategory); //TODO Change it to store.state
            },
        },
        mounted(){
            this.selectedCategoriesValue = this.selectedCategories;
            if (this.selectedSubCategory === ALL_VALUE || this.selectedSubCategory.length === 0 || JSON.stringify(this.selectedSubCategory) === JSON.stringify([ALL_VALUE])) {
                if (this.selectedCategory !== [ALL_VALUE]) {
                    this.selectedSubCategory = Object.keys(this.selectedCategoriesValue).filter(item => item.parentId !== null);
                    this.selectedCategoriesPill = Object.values(this.selectedCategoriesValue).filter(item => item.parentId !== null);

                } else {
                    this.selectedSubCategory = [this.selectedSubCategory];
                }
            } else {
                for (const key of this.selectedSubCategory) {
                    if (key in this.selectedCategoriesValue) {
                        this.selectedCategoriesPill.push(this.selectedCategoriesValue[key]);
                    }
                }
            }
            if (JSON.stringify(this.selectedCategory) !== JSON.stringify([ALL_VALUE])) {
                this.selectedSubCategory = Object.keys(this.selectedCategoriesValue).filter(item => item.parentId !== null);
                this.selectedCategoriesPill = Object.values(this.selectedCategoriesValue).filter(item => item.parentId !== null);

            } else {
                this.selectedSubCategory = [this.selectedSubCategory];
            }
        },
        setup() {
            const getters = {
                ...useGetters('search', [
                    'category',
                    'subCategory',
                    'branchesData',
                    'selectedSubIndustries',
                    'selectedCategories',
                ]),
            };
            const actions = {
                ...useActions('search', [
                    'setSubCategoryInitial',
                ]),
            };
            async function setSubCategories() {
                await actions.setSubCategoryInitial();
            }

            return {
                ...getters,
                setSubCategories,
            };
        },
    };
</script>
